<script>
export default {
  name: "create_maintenance_buttons",
  props: {
    disabledGoToManifest: {
      type: Boolean,
      default: false,
    },
    hideBtnManifest:{
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    }
  },
  computed: {
    comment: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    submit() {
      this.$emit("submit");
    },
    back() {
      this.$emit("back");
    },
    editManifest() {
      this.$emit("editManifest");
    },
  }
}
</script>

<template>
  <div class="d-flex justify-content-center gap-2">
    <div class="approve-comment">
      <b-form-input
        placeholder="修正内容"
        v-model="comment"
      ></b-form-input>
    </div>
    <button
      class="btn btn-primary waves-effect waves-light"
      @click="submit"
    >
      <i class="fas fa-pencil-alt"></i> {{ this.$lang.button.register }}
    </button>
    <button
      class="btn btn-primary waves-effect waves-light"
      @click="back"
    >
      <i class='far fa-arrow-alt-circle-left'></i> {{ this.$lang.button.back }}
    </button>
    <button
      v-if="!hideBtnManifest"
      :disabled="disabledGoToManifest"
      class="btn btn-primary waves-effect waves-light"
      @click="editManifest"
    >
      <i class="fas fa-file-alt"></i> マニフェスト
    </button>
  </div>
</template>
